import { MedicalCasePageCriteria } from '../../../domain/medical-case/model/medical-case-page-criteria';

export namespace MedicalCaseActions {
  const prefix = '[MedicalCase]';

  export class GetPage {
    static readonly type = `${prefix} Get page`;

    constructor(readonly criteria: MedicalCasePageCriteria) {}
  }

  export class RefreshPage {
    static readonly type = `${prefix} Refresh page`;

    constructor() {}
  }

  export class InvalidateCache {
    static readonly type = `${prefix} Invalidate cache`;

    constructor() {}
  }

  export class GetById {
    static readonly type = `${prefix} Get by id`;

    constructor(readonly id: string) {}
  }

  export class GetByIdSilent {
    static readonly type = `${prefix} Get by id silent`;

    constructor(readonly id: string) {}
  }
}
